import request from '../utils/request'

/**
 * 获取仓库列表（内勤端）
 */
export function getWarehouseList(params) {
  return request({
    url: '/internal/warehouse/list',
    method: 'get',
    params
  })
}

/**
 * 获取仓库详情（内勤端）
 */
export function getWarehouseDetail(id) {
  return request({
    url: `/internal/warehouse/${id}`,
    method: 'get'
  })
}

/**
 * 创建仓库（内勤端）
 */
export function createWarehouse(data) {
  return request({
    url: '/internal/warehouse',
    method: 'post',
    data
  })
}

/**
 * 更新仓库（内勤端）
 */
export function updateWarehouse(data) {
  return request({
    url: '/internal/warehouse',
    method: 'put',
    data
  })
}

/**
 * 删除仓库（内勤端）
 */
export function deleteWarehouse(id) {
  return request({
    url: `/internal/warehouse/${id}`,
    method: 'delete'
  })
}

